import { Component, Inject, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ApiService} from '../../../../../src/app/services/api.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';


@Component({
    selector: 'pending-blocks-alert-component',
    templateUrl: './pending-blocks-alert.component.html',
    styles: [
        `
        .mat-progress-bar {
            height: 3px !important;
        }
        `
    ]
})
export class PendingBlocksAlertComponent implements OnInit {
    PendingJobsCounter: any = 0;
    mode: ProgressSpinnerMode = 'determinate';
    appMinutes;
    timerText = 'Your wait time is approximately ';
    constructor(
        public dialogRef: MatDialogRef<PendingBlocksAlertComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private apiService: ApiService
    ) { }

    ngOnInit(): void {
        this.timerText = this.getTimerText(this.data.PendingJobs);
        this.checkForPendingJobs();
    }

    checkForPendingJobs() {
        this.apiService.resumeApplication(this.data.resumePayload).subscribe(response => {
            const count = response.data.PendingJobs === 'jhade' ? 1 : response.data.PendingJobs;
            if (count) {
                if (this.PendingJobsCounter === count) {
                    this.timerText = this.getTimerText(response.data.PendingJobs);
                    setTimeout(() => this.delayCall(), 5000);
                } else {
                    this.checkForPendingJobs();
                }
                this.PendingJobsCounter = count;
            } else {
                this.dialogRef.close(response);
            }
        });
    }

    delayCall() {
        this.checkForPendingJobs();
    }

    getTimerText(pendingJobs: any): string {

        if (pendingJobs === 'jhade') {

            console.log('JHADE queue')
            return `Your wait time is approximately 1 minute`;

        } else {
            // each block takes about 10 seconds to get submitted
            this.appMinutes = Math.ceil((pendingJobs * 10) / 60) + 1;

            return `Your wait time is approximately ${this.appMinutes} minute${this.appMinutes < 2 ? 's':''}`

           
        }
    }
}
